import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { ClinicianDescription, PatientDemographics } from '../../patient';
import { ClinicianService } from '../../clinician.service';
import { Observable } from 'rxjs';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatCardModule } from '@angular/material/card';
import { CohortMembershipListComponent } from '../../cohort-membership-list/cohort-membership-list.component';
import { BreadcrumbService } from 'xng-breadcrumb';
import {MatSelectModule} from "@angular/material/select";

@Component({
  selector: 'app-clinician-admin',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatListModule,
    MatCardModule,
    CohortMembershipListComponent,
    RouterLink,
    MatSelectModule,
  ],
  templateUrl: './clinician-admin.component.html',
  styleUrls: ['./clinician-admin.component.scss'],
})
export class ClinicianAdminComponent implements OnInit {
  private clinicianUuid: string;

  public profile: Observable<ClinicianDescription> | null = null;

  public roleString : string = "";

  constructor(
    private clinicianService: ClinicianService,
    private route: ActivatedRoute,
    private breadcrumbService: BreadcrumbService,
  ) {
    this.clinicianUuid = this.route.snapshot.paramMap.get('id') || '';
    this.breadcrumbService.set('@clinicianName', 'Clinician');

  }

  ngOnInit(): void {
    this.profile = this.clinicianService.getClinicianProfile(
      this.clinicianUuid,
    );
    this.profile?.subscribe((x) => {
      this.breadcrumbService.set('@clinicianName', 'Clinician: ' + x.username);
      this.roleString = this.getRoleValue( x );
    });
  }

  getRoleValue(p: ClinicianDescription) {
    if( p.isAdmin ) { return "Admin" }
    else if( p.isPartnerAdmin ) { return "PartnerAdmin" }
    else if( p.isClinician) { return "Clinician" }
    else if ( p.isPatient ) { return "Patient" }
    return "ERROR"
  }
}
